import { type UserPlan } from '~/types/Plan';

import { OnboardingLocalStorageKeys } from '../types/onboarding.type';

export const formatTrialEndDate = (endDate: UserPlan['endDate'], language: string): string =>
  endDate
    ? new Intl.DateTimeFormat(language, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }).format(endDate.toDate())
    : '';

export const setOnboardingInProgress = (value: boolean) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS, value.toString());

export const getOnboardingInProgress = (): boolean =>
  localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS) === 'true';

const clearOldOnboardingLocalStorage = () =>
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_TYPE);

export const clearOnboardingLocalStorage = () => {
  clearOldOnboardingLocalStorage();
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS);
};
